var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"match-height"},_vm._l((_vm.statisticsData),function(data){return _c('v-col',{key:data.title,staticClass:"align-center",attrs:{"cols":"4","md":"4","sm":"4","xs":"4"}},[_c('statistics-single-card',{attrs:{"title":data.title,"color":data.color,"icon":data.icon,"value":data.value}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }